/*状态对象*/
export default{
      ruleForm:{},
      voluearr:[]
    } 


// WEBPACK FOOTER //
// ./src/store/state.js